<div class="donations-report-dialog">
  <div mat-dialog-title class="donations-report-dialog__header">
    <div class="donations-report-dialog__context">Exportação</div>
    <h1 class="donations-report-dialog__title">Configurar PDF</h1>
  </div>

  <div mat-dialog-content class="donations-report-dialog__content">
    <div class="donations-report-dialog__layout">
      <div class="donations-report-dialog__column">
        <section class="donations-report-dialog__section">
          <div class="donations-report-dialog__section-head">
            <h2>Listagens</h2>
          </div>

          <div class="donations-report-dialog__options">
            <mat-checkbox [(ngModel)]="hasPaidListing">
              Listar pagos
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="hasPromisedListing">
              Listar prometidos
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="hasToContactListing">
              Listar a contactar
            </mat-checkbox>
          </div>
        </section>

        <section class="donations-report-dialog__section">
          <div class="donations-report-dialog__section-head">
            <h2>Apresentação</h2>
          </div>

          <div class="donations-report-dialog__options">
            <mat-checkbox [(ngModel)]="groupByLocation">
              Agrupar por localidade
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="hideResponsiblePerson">
              Esconder responsáveis
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="hidePaidValue">
              Esconder valor pago
            </mat-checkbox>
          </div>
        </section>
      </div>

      <section class="donations-report-dialog__section donations-report-dialog__section--filters">
        <div class="donations-report-dialog__section-head">
          <h2>Filtros</h2>
        </div>

        <div class="donations-report-dialog__fields">
          <mat-form-field class="donations-report-dialog__field" appearance="outline">
            <mat-label>Localidade</mat-label>
            <mat-select [(ngModel)]="locationId">
              <mat-option value="">Todas</mat-option>
              @for (option of locationsOptions$ | async; track option) {
                <mat-option [value]="option.value">
                  {{ option.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div class="donations-report-dialog__options donations-report-dialog__options--inline">
            <mat-checkbox [(ngModel)]="filterByDates" (change)="onFilterByDatesChange($event)">
              Filtrar por datas
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="valuesInterval">
              Intervalo de valores
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="onlySpecialDonorRole">
              Apenas mordomos
            </mat-checkbox>
          </div>

          @if (filterByDates) {
            <mat-form-field
              class="donations-report-dialog__field"
              appearance="outline">
              <mat-label>Datas</mat-label>
              <mat-date-range-input [rangePicker]="dateRangePicker">
                <input matStartDate placeholder="Data de início" [(ngModel)]="startDate">
                <input matEndDate placeholder="Data final" [(ngModel)]="endDate">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
          }

          @if (valuesInterval) {
            <div class="donations-report-dialog__values-grid">
              <mat-form-field class="donations-report-dialog__field" appearance="outline">
                <mat-label>Mínimo</mat-label>
                <input matInput type="number" [(ngModel)]="minValue">
              </mat-form-field>
              <mat-form-field class="donations-report-dialog__field" appearance="outline">
                <mat-label>Máximo</mat-label>
                <input matInput type="number" [(ngModel)]="maxValue">
              </mat-form-field>
            </div>
          }
        </div>
      </section>
    </div>
  </div>

  <div mat-dialog-actions class="donations-report-dialog__actions">
    <button
      mat-stroked-button
      type="button"
      class="donations-report-dialog__button donations-report-dialog__button--secondary"
      [mat-dialog-close]="false">
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="donations-report-dialog__button donations-report-dialog__button--primary"
      (click)="confirmSelection()">
      Exportar PDF
    </button>
  </div>
</div>
